import { render, staticRenderFns } from "./CommunitySideMenuSection.vue?vue&type=template&id=545c94d2&scoped=true&"
import script from "./CommunitySideMenuSection.vue?vue&type=script&lang=js&"
export * from "./CommunitySideMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySideMenuSection.vue?vue&type=style&index=0&id=545c94d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c94d2",
  null
  
)

export default component.exports